import WalletTransfer from './WalletTransfer';

export default WalletTransfer;
